import { FC, useEffect, useRef, useState } from 'react'
import Head from 'next/head'

export type TcDatalayer = {
  env_work?: string
  env_template?: string
  level2_id?: string
  level2_name?: string
  page_cat1?: string
  page_cat2?: string
  page_cat3?: string
  page_cat4?: string
  page_template?: string
  page_name?: string
  contains_form_infos?: boolean
  form_name?: string
  form_has_step?: boolean
  form_step_number?: number
  form_step_name?: string
  form_is_confirmation?: boolean
  form_id?: string
  contains_video_infos?: boolean
  video_list?: string
  video_action?: string
  contains_filter_infos?: boolean
  list_filters?: {
    'type de plat'?: string[]
    'recette express'?: string
    'régime alimentaire'?: string
  }
  contains_search_result_pages?: boolean
  search_keyword?: string
  contains_goal_infos?: boolean
  goal_fruit_vegetable?: string
  goal_starchy?: string
  goal_dried_vegetable?: string
  goal_fish?: string
  goal_meat?: string
  goal_sweet_drink_and_product?: string
  contains_preferences_infos?: boolean
  preferences_number_people?: string
  preferences_diet?: string
  preferences_meal_composition?: string
  preferences_cook?: string
  preferences_meal_number?: string
}

export type TcProps = {
  datalayer: TcDatalayer
  scriptHead?: string
  triggerTcUpdate?: number
}

const Seo: FC<TcProps> = (props) => {
  const { datalayer, scriptHead, triggerTcUpdate } = props
  const oldTriggerValue = useRef(triggerTcUpdate)
  const [isMounted, setIsMounted] = useState(false) // call the reload at mount and when triggerTcUpdate changes

  useEffect(() => {
    if (oldTriggerValue.current === triggerTcUpdate && isMounted) {
      return
    }
    ;(window as typeof window & { tC: any })?.tC?.container?.reload({
      events: { pageLoad: [{}, {}] },
    })
    setIsMounted(true)
  }, [triggerTcUpdate, isMounted])

  if (!datalayer.env_work) {
    return null
  }

  return (
    <Head>
      <script
        dangerouslySetInnerHTML={{
          __html: `var tc_vars = ${JSON.stringify(datalayer)}`,
        }}
      />
      {scriptHead && <script src={scriptHead} />}
    </Head>
  )
}

export default Seo
